(function () {
    $(document).on('blur', 'input[type="number"]:not(.nullable)', function (event) {
        var self = $(this);

        if (self.attr('min') && parseFloat(this.value) < parseFloat(self.attr('min'))) {
            self.val(self.attr('min'));
        }

        if (self.attr('max') && parseFloat(this.value) > parseFloat(self.attr('max'))) {
            self.val(self.attr('max'));
        }

        var valueAsFloat = parseFloat(this.value);

        switch (self.data('type')) {
            case 'decimal':
            case 'float':
            case 'double':
                self.val(valueAsFloat.toFixed(2));
                break;
            case 'integer':
            case 'byte':
            case 'long':
            case 'short':
                self.val(parseInt(valueAsFloat));
                break;
        }
    }).on('keypress', 'input, select, textarea', function (event) {
        if (this.tagName.toLowerCase() == 'input' && this.type.toLowerCase() == 'number' && event.keyCode == 44) { // keyCode 44 is ","
            return;
        }
        var self = this;
        setTimeout(function () { self.setAttribute('value', self.value); }, 1);
    }).on('keydown', 'input[readonly], select[readonly], textarea[readonly]', function (e) {
        e.stopPropagation();
        return false;
    }).on('keypress', 'input[type="number"]', function (event) {
        if (event.keyCode == 13) {
            this.blur();
        }
    }).on('keydown', 'input, textarea', function (event) {
        var key = event.keyCode || event.charCode;

        if (key == 8 || key == 46) {
            var self = this;
            setTimeout(function () { self.setAttribute('value', self.value); }, 1);
        }
    }).on('blur', 'input, textarea', function (event) {
        var self = this;
        setTimeout(function () { self.setAttribute('value', self.value); }, 1);
    });

    $(window).on('load', function (event) {
        $('*[data-val-required][value=""]:not([type="hidden"]):eq(0)').focus();

        $('select:not(.loading):not(:has(option))').css('border-color', '#c0392b');

        let $dragndrop = $('.dragndrop');
        if ($dragndrop && $dragndrop.length) {
            let isDragAndDropSupported = gb.isDragAndDropSupported();

            $dragndrop.each((index, element) => {
                let files = null;
                console.log(files)
                let $self = $(element);
                let $form = $self.closest('form').on('submit', (e) => {
                    e.preventDefault();

                    if (files) {
                        let $uploading = $self.find('.dragndrop_uploading').empty();
                        $uploading.append($uploading.data('text') + '<span class="filename"> ' + files[0].name + '</span>');
                        $self.addClass('uploading').removeClass('success error');
                        $('.verification').removeClass('verified unverified').prev('.step').addClass('disabled');

                        let formData = new FormData();

                        formData.append('file', files[0]);
                        $.ajax({
                            url: $form.attr('action'),
                            type: $form.attr('method'),
                            data: formData,
                            dataType: 'json',
                            cache: false,
                            contentType: false,
                            processData: false,
                            complete: function () {
                                $self.removeClass('uploading');
                            },
                            success: function (data) {
                                $self.addClass(data.validDocument == true ? 'success' : 'error');
                                $('.verification').prev('.step').removeClass('disabled');

                                if (data.validDocument) {
                                    !function (element) {
                                        element.html('<span class="filename">' + files[0].name + '</span><span> ' + element.data('text') + '</span>');
                                    }($self.find('.dragndrop_success'));

                                    if (data.verified) { // No errors
                                        let $verificationSuccess = $('.verification-success');
                                        $verificationSuccess.empty().html('<div class="verification-message">' + data.message + '</div><div class="verification-message">' + $verificationSuccess.data('text') + '</div>');
                                        $('.verification').addClass('verified');
                                        $self.removeClass('error uploading');
                                        if (data.fileType == "image") {
                                                var reader = new FileReader();
                                                reader.readAsDataURL(files[0]);
                                            reader.onload = function (e) {
                                                $('#custom-mail-logo').removeClass('hidden')
                                                $('#custom-mail-logo').attr('src', e.target.result);

                                                //used in customMail
                                                $('.logo-wrapper').children().first().children().last().addClass('hidden');
                                                $('.logo-wrapper > .icon-trash_can').removeClass('hidden');
                                            }
                                        }
                                    } else {
                                        let $verificationError = $('.verification-error');
                                        $verificationError.empty().html('<div class="verification-message">' + data.message + '</div><div class="verification-message">' + $verificationError.data('text') + '</div>' + (data.errors ? '<ul>' + data.errors.map((e) => { return '<li>' + e + '</li>'; }).join('') + '</ul>' : ''));
                                        $('.verification').addClass('unverified');
                                        $self.removeClass('error uploading success');
                                    }
                                } else {
                                    !function (element) {
                                        element.html('<span class="filename">' + files[0].name + '</span><span> ' + element.data('text') + '</span>');
                                    }($self.find('.dragndrop_error'));
                                    $self.removeClass('success uploading');
                                }

                                $self.closest('.modalbox').find('.ok-button').attr('disabled', (!data.verified || !data.validDocument));
                            },
                            error: function () {
                                $self.addClass('error').removeClass('success uploading');
                            }
                        });
                    }
                });

                $form.find('input[type=file]').on('change', (event) => {
                    files = event.target.files;
                    $form.trigger('submit');
                });

                if (isDragAndDropSupported) {
                    $self.addClass('dragndrop-supported');

                    $form.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    })
                    .on('dragover dragenter', function () {
                        $self.addClass('has-dragover');
                    })
                    .on('dragleave dragend drop', function () {
                        $self.removeClass('has-dragover');
                    })
                    .on('drop', function (e) {
                        files = e.originalEvent.dataTransfer.files;
                        $form.trigger('submit');
                    });
                }
            });
        }
    });
})();

$(function (event) {
    $('input[required]:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), input[data-val-required]:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), select[required], select[data-val-required], textarea[required], textarea[data-val-required]').each(function () {
        let $parent = $(this).parent();
        let iterations = 0;
        while ($parent && $parent.length && (iterations++ < 4)) {
            let $label = $parent.children('.labelForInput');
            if ($label && $label.length && !$label.data('has-asterisk')) {
                let labelContent = $label.data('has-asterisk', 'true').html();
                let indexOfHtml = labelContent.indexOf('<');

                if (indexOfHtml !== -1) {
                    $label.html(labelContent.substring(0, indexOfHtml) + ' <b>*</b> ' + labelContent.substring(indexOfHtml));
                } else {
                    $label.append(' <b>*</b>');
                }
                break;
            } else {
                $parent = $parent.parent();
            }
        }
    });
});